import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";

const DiversionSanPedro = ({ hasBg = true }) => {
  return (
    <>
      <section
        id="diversion"
        className={`screenshots-section ptb-100 ${
          hasBg ? "gray-light-bg" : ""
        }`}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="section-heading text-center">
                {hasBg ? (
                  <span className="text-uppercase color-secondary sub-title">
                    Playa, Fiesta y mas
                  </span>
                ) : (
                  ""
                )}
                <h2>San pedro un destino inigualable</h2>
                <p className="lead">
                  Disfrutarás de un predio con todas las comodidades, sin
                  necesidad de trasladarte a otras locaciones. Contamos con
                  playa, parques, centros de juego y entretenimiento, además de
                  profesionales del sector estudiantil y prestadores de
                  servicios de primer nivel. Nuestro equipo humano de excelencia
                  es uno de los puntos más destacados que han llevado a Up Grade
                  a ser la empresa más recomendada. Miles de estudiantes ya han
                  vivido su viaje con nosotros. ¡Únete y vive una experiencia
                  inolvidable!
                </p>
              </div>
            </div>
          </div>
          <Swiper
            modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
            centeredSlides={true}
            spaceBetween={50}
            slidesPerView={1}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            loop={true}
            pagination={{ clickable: true }}
            onSwiper={(swiper) => console.log(swiper)}
          >
            <SwiperSlide>
              <img
                src="assets/img/sanpedro/diversion/imagenessanpedropri1.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/sanpedro/diversion/imagenessanpedropri2.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/sanpedro/diversion/imagenessanpedropri3.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/sanpedro/diversion/imagenessanpedropri4.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/sanpedro/diversion/imagenessanpedropri5.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/sanpedro/diversion/imagenessanpedropri6.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/sanpedro/diversion/imagenessanpedropri7.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/sanpedro/diversion/imagenessanpedropri8.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/sanpedro/diversion/imagenessanpedropri9.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default DiversionSanPedro;
